import api from "./api";

// Etapas do funil de negociacao da empresa logada.
// Cada empresa define as suas em Configuracoes do funil; quem nao definiu usa a lista abaixo.
const PADRAO = [
  { id: "prospeccao",   label: "Prospecção",   color: "#579bfc", tipo: "novo" },
  { id: "qualificacao", label: "Qualificação", color: "#3B7FD6", tipo: "contato" },
  { id: "reuniao",      label: "Reunião",      color: "#8B5CF6", tipo: "contato" },
  { id: "proposta",     label: "Proposta",     color: "#EE6A1A", tipo: "contato" },
  { id: "negociacao",   label: "Negociação",   color: "#EBA13A", tipo: "contato" },
  { id: "ganho",        label: "Ganho",        color: "#1D9E75", tipo: "ganho" },
  { id: "perdido",      label: "Perdido",      color: "var(--text-muted)", tipo: "perdido" },
];

let cache = null;

function doLocal() {
  try {
    const c = JSON.parse(localStorage.getItem("crm_funil") || "null");
    if (c && Array.isArray(c.etapasNegociacao) && c.etapasNegociacao.length) return c.etapasNegociacao;
  } catch (e) {}
  return PADRAO;
}

// Leitura imediata, para o modulo montar sem esperar o servidor
export function etapas() { return cache || doLocal(); }

// Guarda o que veio de /funil sem apagar a outra lista
export function guardarFunil(data) {
  let atual = {};
  try { atual = JSON.parse(localStorage.getItem("crm_funil") || "{}") || {}; } catch (e) {}
  const novo = Object.assign({}, atual);
  if (data && Array.isArray(data.statusLead) && data.statusLead.length) novo.statusLead = data.statusLead;
  if (data && Array.isArray(data.etapasNegociacao) && data.etapasNegociacao.length) novo.etapasNegociacao = data.etapasNegociacao;
  try { localStorage.setItem("crm_funil", JSON.stringify(novo)); } catch (e) {}
  cache = novo.etapasNegociacao && novo.etapasNegociacao.length ? novo.etapasNegociacao : PADRAO;
  return cache;
}

export async function carregarFunil() {
  try {
    const { data } = await api.get("/funil");
    return guardarFunil(data);
  } catch (e) { return etapas(); }
}

export function limparFunilLocal() { cache = null; }

export function etapaPor(id) {
  const l = etapas();
  return l.find((e) => e.id === id) || l[0];
}

export function primeiraEtapa() {
  const l = etapas();
  return (l.find((e) => e.tipo === "novo") || l[0] || { id: "prospeccao" }).id;
}

// Mesma lista, com a cor de fundo clara que o Kanban usa
export function etapasKanban(lista) {
  return (lista || etapas()).map((e) => Object.assign({}, e, {
    bg: /^#[0-9a-fA-F]{6}$/.test(String(e.color)) ? e.color + "1a" : "var(--hover-bg)",
  }));
}
